import { createSelector } from "@reduxjs/toolkit";
import { choSearch, registQuery } from "../../functions/searchFunctions";
import { LOCALES } from "../../constants";

const rarity_score = {
    IG_LEGENDARY: 0,
    IG_UNIQUE: 1,
    IG_RARE: 2,
};

const type_score = {
    NT_CHARM: 0,
    NT_COOK: 1,
    NT_TRAINING_EXP_ITEM: 2,
    NT_VALUABLES: 3,
};

const lang = localStorage.getItem("language") || LOCALES.KO;

const baseSort = (a, b) =>
    type_score[a.type] - type_score[b.type] ||
    rarity_score[a.rarity] - rarity_score[b.rarity] ||
    a.name[lang].localeCompare(b.name[lang], lang);

const nameAscSort = (a, b) => a.name[lang].localeCompare(b.name[lang], lang);

const rarityAscSort = (a, b) => rarity_score[b.rarity] - rarity_score[a.rarity];

const rarityDescSort = (a, b) => rarity_score[a.rarity] - rarity_score[b.rarity];

const selectLang = (state) => state.lang;

export const selectItemState = (state) => state.items;

export const selectItemIds = (state) => selectItemState(state).ids;

export const selectItemEntities = (state) => selectItemState(state).entities;

export const selectItemFilter = (state) => selectItemState(state).filter;

const filterByType = (item, typeValue) => {
    if (typeValue === "all") return true;
    return typeValue === item.type;
};

const searchItemByText = (lang, item, query) => {
    if (query.trim() === "") return true;
    const q = String(query).trim();

    registQuery(lang, q);
    const searchText = lang === LOCALES.KO ? item.searchText : item.searchText_ENG;
    return choSearch(searchText);
};

const sortByType = (a, b, sortValue) => {
    if (sortValue === "all") return baseSort(a, b);
    else if (sortValue === "name-asc") return nameAscSort(a, b);
    else if (sortValue === "rarity-asc") return rarityAscSort(a, b);
    else if (sortValue === "rarity-desc") return rarityDescSort(a, b);
    return baseSort(a, b);
};

export const selectFilteredItems = createSelector(
    [selectItemIds, selectItemEntities, selectItemFilter, selectLang, (_, query) => query],
    (ids, entities, filter, lang, query) => {
        return ids
            .map((id) => entities[id])
            .filter((item) => filterByType(item, filter.type.value))
            .filter((item) => searchItemByText(lang.value, item, query))
            .sort((a, b) => sortByType(a, b, filter.sort.value));
    },
);

export const selectItemById = createSelector([selectItemEntities, (_, itemId) => itemId], (entities, itemId) => entities[itemId]);

export const selectItemsByType = createSelector([selectItemIds, selectItemEntities, (_, itemType) => itemType], (ids, entities, itemType) =>
    ids.map((id) => entities[id]).filter((item) => item.type === itemType),
);

export const selectItemsByRarity = createSelector([selectItemIds, selectItemEntities, (_, rarity) => rarity], (ids, entities, rarity) =>
    ids.map((id) => entities[id]).filter((item) => item.rarity === rarity),
);
